export default defineNuxtPlugin(() => {
    if (process.client) {
        const loadKeyCRMScript = () => {
            (function (w, d, t, u, c) {
                const s = d.createElement(t),
                    j = d.getElementsByTagName(t)[0];
                s.src = u;
                s.async = true;
                s.defer = true;
                s.onload = () => {
                    if (window.KeyCRM) {
                        window.KeyCRM.render(c);
                    }
                };
                j.parentNode.insertBefore(s, j);
            })(window, document, "script", "https://chat.key.live/bundles/widget.min.js", {
                token: "07125581-5055-49fd-962c-e68cc29cec34",
            });
        };

        const onScroll = () => {
            loadKeyCRMScript();
            window.removeEventListener("scroll", onScroll); // Удаляем обработчик после первого вызова
        };

        window.addEventListener("scroll", onScroll); // Добавляем обработчик события прокрутки
    }
});